export default __webpack_public_path__ + "static/media/Cancelled.075f340d.png";